import * as _ from "lodash";
import {Node} from "../Node";
import {AbstractProperty} from "./AbstractProperty";
import {json, MetadataRow} from "../../global";

export class PMap extends AbstractProperty<MetadataRow, Node> {

    default: MetadataRow;

    constructor(args) {
        super({
            type: 'Map',
            default: null,
            ...args,
        });
    }

    typeCheck(value) {
        return _.isPlainObject(value);
    }

    isEqual(a: MetadataRow, b: MetadataRow): boolean {
        return _.isEqual(a,b);
    }

}
